import { useQuery } from '@hooks/reactQuery';

import { getAssignedApprovalUnits } from '@api/assignApprovalUnit';

import { extractQueryParams } from '@utils/common';

import { IAttachedApprovalUnitDTO } from '@interfaces/organisation/dto/approvalUnitsDTO';

import { refetchOptions } from '@constants/common';
import { ASSIGN_APPROVAL_UNITS } from '@constants/queryKeys';

interface IUseQueryAssignedApprovalUnitsProps extends IAttachedApprovalUnitDTO {
	closeAddModal?: () => void;
}

export const useQueryAssignedApprovalUnits = (params: IUseQueryAssignedApprovalUnitsProps) => {
	const {
		data,
		isLoading: isLoadingApprovalUnit,
		isFetching: isFetchingApprovalUnit,
	} = useQuery({
		queryKey: [
			ASSIGN_APPROVAL_UNITS,
			params,
		],
		queryFn: extractQueryParams(getAssignedApprovalUnits),
		...refetchOptions,
	});

	return {
		approvalAssignUnitData: data?.items || [],
		countOfRecords: data?.count || 0,
		isLoadingApprovalUnit: isLoadingApprovalUnit || isFetchingApprovalUnit,
	};
};
